import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import ImportStatusReportCriteria from './ImportStatusReportCriteria';


@NeoReport("ImportStatus",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class ImportStatusReport extends Report<ImportStatusReportCriteria>{

    constructor() {
        super(ImportStatusReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}